import {AddressesV1Addresses} from "./AddressesV1Addresses";
import {AuthorizationProvider} from "@infonova/framework/lib/security/AuthorizationProvider";
import { Address } from "../types/Address";

/**
 * Example implementation for accessing an API.
 */
export class AddressesV1AddressesImpl implements AddressesV1Addresses {

    private url: string;

    constructor(r6ApiBaseUrl: string, private authorizationProvider: AuthorizationProvider) {
        this.url = r6ApiBaseUrl + "/addresses/v1/addresses";

    }

    async getAddress(id: string): Promise<Address> {
        const authorization = await this.authorizationProvider.getAuthorizationInformation();
        const headers = {
            ...authorization.header,
            'Content-Type': 'application/json; charset=UTF-8'
        }
        const url = this.url + "/{id}".replace('{id}', id);
        return fetch(url, {
            method: 'GET',
            headers
        }).catch((response) => {
        }).then((response) => {
            if (response) {
                if (response.ok) {
                    return response.json();
                } else {
                    return Promise.reject(response.json());
                }
            }
        });
    }

}